// src/components/CustomDiv.js
import React from "react";

const Field = ({ label, children }) => {
  return (
    <div className="py-4 border-t border-gray-300">
      <label htmlFor="inputField" className="text-sm font-bold uppercase">
        {label}
      </label>
      
      {children}
    </div>
  ); 
};

export default Field;
